
import { motion } from 'motion/react'
import { Icon } from '@/components/ui/icon'

export function SharedPage() {
  return (
    <main className="h-full overflow-hidden">
      <div className="h-full overflow-y-auto">
        <div className="w-full">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            className="flex flex-col items-center pt-[33vh]"
          >
            <div className="text-center">
              <Icon name="share-2" className="mx-auto h-12 w-12 text-muted-foreground" />
              <h3 className="mt-4 text-sm font-semibold">Shared with me</h3>
              <p className="mt-2 text-sm text-muted-foreground">
                Sessions shared with you will appear here.
              </p>
              <p className="mt-1 text-xs text-muted-foreground/60">
                Coming soon
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </main>
  )
}
